export default theme => ({
  root: {},
  tableRow: {
    height: '64px'
  },
  tableCell: {
    whiteSpace: 'nowrap'
  },
  tableCellInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  nameText: {
    display: 'inline-block',
    fontWeight: 500,
  }
});
